module.exports = __webpack_public_path__ + "static/media/badge_ptrnC.0a5065dc.png";